import { createEvent, restore } from 'effector'

export const storageVideoVisibilityChanged = createEvent<boolean>()
export const $storageVideoVisibility = restore(storageVideoVisibilityChanged, false)

export const inputValueChanged = createEvent<string>()
export const $inputValue = restore(inputValueChanged, '')
